import SearchResult from '@/core/search/SearchResult';

export default class TaskSearchResult extends SearchResult {
}
